import Api from '../../config/Api'
import { EventoHistory, GetResponse } from '../../models'

export const getByEventoId = async (eventoId: string) => {
    return Api.get<GetResponse<EventoHistory[]>>(`EventoHistory?Condition=eventoId=%22${eventoId}%22&Offset=0&Limit=-1&OrderBy=dataCriacao&SortDesc=false`)
}